import i18n from '@/plugins/i18n.js'
import api from '@/script/api.js'
import { generateUuid, getFileExt } from '@/script/utils'

export default {
  async getGroupId({ commit }, userId) {
    const resGroupId = await api.getGroupId(userId)

    if (!resGroupId || resGroupId.status !== 200) {
      commit('TOGGLE_LOADING', false)
      commit('ADMIN_VIDEO_ERROR', true)

      return false
    }

    const groupId = resGroupId.data.groupId
    commit('UPDATE_GROUP_ID', groupId)

    return groupId
  },

  async getConfigurations({ commit }, groupId) {
    const videoConfigurations = await api.getConfigurations(groupId)

    if (!videoConfigurations || videoConfigurations.status !== 200) {
      commit('TOGGLE_LOADING', false)
      commit('ADMIN_VIDEO_ERROR', true)

      return false
    }

    return videoConfigurations
  },

  async createNewConfiguration({ commit }, groupId) {
    const videoConfigurations = await api.createConfiguration(groupId)

    if (!videoConfigurations || videoConfigurations.status !== 201) {
      commit('TOGGLE_LOADING', false)
      commit('ADMIN_VIDEO_ERROR', true)
      return false
    }

    return videoConfigurations
  },

  async getAdminVideoConfigurations({ commit, dispatch }, userId) {
    let videoConfigurations, configurationVideo, idConfigurationVideo
    commit('TOGGLE_LOADING', true)

    const groupId = await dispatch('getGroupId', userId)
    if (!groupId) return false

    videoConfigurations = await dispatch('getConfigurations', groupId)
    if (!videoConfigurations) return false

    if (videoConfigurations.data.length === 0) {
      videoConfigurations = await dispatch('createNewConfiguration', groupId)
      if (!videoConfigurations) return false
      idConfigurationVideo = videoConfigurations.data.idConfigurationVideo
      configurationVideo = [{ idConfigurationVideo: idConfigurationVideo }]
    } else {
      configurationVideo = videoConfigurations.data
      idConfigurationVideo = configurationVideo[0].idConfigurationVideo
    }

    commit('UPDATE_UUID_ADMIN_VIDEO', idConfigurationVideo)
    commit('UPDATE_VIDEO_CONFIGURATION', configurationVideo)
    commit('TOGGLE_LOADING', false)
    return true
  },

  async getAdminVideoConfigurationsWithoutCheck({ commit }) {
    const groupId = this.state.adminVideo.groupId
    const videoConfigurations = await api.getConfigurations(groupId)

    if (!videoConfigurations || videoConfigurations.status !== 200) {
      commit('ADMIN_VIDEO_ERROR', true)
      return false
    } else {
      commit('UPDATE_VIDEO_CONFIGURATION', videoConfigurations.data)
      return true
    }
  },

  async generatePresignedUrlFromMedia({ commit, dispatch }, mediaFile) {
    const snackMessageError = i18n.t('adminVideo.fileUploadError')

    let uuid = generateUuid()
    let ext = getFileExt(mediaFile)

    const res = await api.generatePresignedUrlFromMedia([{ name: uuid, extension: ext }])

    if (!res || res.status !== 201) {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' }, { root: true })
      return false
    } else {
      return res
    }
  },

  async sendMedia({ commit, dispatch }, payload) {
    const { mediaType, mediaFile } = payload
    const snackMessageError = i18n.t('adminVideo.fileUploadError')
    const snackMessageErrorVideoFormat = i18n.t('adminVideo.fileVideoFormatError')
    const snackMessageErrorAudioFormat = i18n.t('adminVideo.fileAudioFormatError')
    const snackMessageSuccess = i18n.t('adminVideo.fileUploadSuccess')

    commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', true)

    if (mediaType === 'audio') {
      if (mediaFile.type !== 'audio/mpeg' && mediaFile.type !== 'audio/ogg') {
        commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
        commit('SET_SNACKBAR', { snack: snackMessageErrorAudioFormat, color: 'error' }, { root: true })
        return false
      }
    } else {
      if (mediaFile.type !== 'video/mp4' && mediaFile.type !== 'video/quicktime') {
        commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
        commit('SET_SNACKBAR', { snack: snackMessageErrorVideoFormat, color: 'error' }, { root: true })
        return false
      }
    }

    // Request for create url and presigned url fir the file
    const res1 = await dispatch('generatePresignedUrlFromMedia', mediaFile)
    if (!res1 || res1.status !== 201) return false

    // Send the file on the tmp bucket with the presigned url
    const res2 = await api.putImageOnS3(res1.data[0].presignedUrl, mediaFile)

    if (!res2 || res2.status !== 200) {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' }, { root: true })
      return false
    }

    // Send the url for copying the file from the tmp bucket to s3.
    const groupId = this.state.adminVideo.groupId
    const idConfigurationVideo = this.state.adminVideo.idConfigurationVideo
    const res3 = await api.modifyMedia(groupId, idConfigurationVideo, mediaType, res1.data[0].url)

    if (!res3 || res3.status !== 200) {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' }, { root: true })
      return false
    } else {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' }, { root: true })
      return true
    }
  },

  async deleteMedia({ commit, dispatch }, mediaType) {
    const snackMessageError = i18n.t('adminVideo.fileDeleteError')
    const snackMessageSuccess = i18n.t('adminVideo.fileDeleteSuccess')

    commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', true)

    const groupId = this.state.adminVideo.groupId
    const idConfigurationVideo = this.state.adminVideo.idConfigurationVideo

    const res = await api.deleteMedia(groupId, idConfigurationVideo, mediaType)

    if (!res || res.status !== 204) {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageError, color: 'error' }, { root: true })
      return false
    } else {
      await dispatch('getAdminVideoConfigurationsWithoutCheck')
      commit('TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA', false)
      commit('SET_SNACKBAR', { snack: snackMessageSuccess, color: 'success' }, { root: true })
      return true
    }
  }
}
